import { FaBuildingNgo } from "react-icons/fa6";
import { GrRestroomWomen } from "react-icons/gr";
import { PiStudentBold } from "react-icons/pi";
import { FaPersonShelter } from "react-icons/fa6";
import { IoHome } from "react-icons/io5";
import { TiGroupOutline } from "react-icons/ti";
import TargetGroups from "../../assets/vitt-vichaar/target_groups.webp";

export default function Features() {
  return (
    <>
      <section className="bg-[#eeb02c] text-white">
        <div className="container mx-auto relative">
          <img src={TargetGroups} className="w-72 mx-auto block py-8" alt="" />

          <div className="grid grid-cols-2 gap-4 md:grid-cols-2 lg:grid-cols-6 text-center">
            <div className="container flex flex-col items-center pb-12 mx-auto text-center">
              <FaBuildingNgo className="w-16 h-16" />
              <h1 className="mt-4 text-md font-semibold text-gray-100">
                Non-Govt. & Govt. Organisations
              </h1>
            </div>

            <div className="container flex flex-col items-center px-4 pb-8 mx-auto text-center">
              <GrRestroomWomen className="w-16 h-16" />
              <h1 className="mt-4 text-md font-semibold text-gray-100">
                Women
              </h1>
            </div>

            <div className="container flex flex-col items-center px-4 pb-8 mx-auto text-center">
              <PiStudentBold className="w-16 h-16" />
              <h1 className="mt-4 text-md font-semibold text-gray-100">
                Students
              </h1>
            </div>
            <div className="container flex flex-col items-center px-4 pb-8 mx-auto text-center">
              <FaPersonShelter className="w-16 h-16" />
              <h1 className="mt-4 text-md font-semibold text-gray-100">
                Old Age & Shelter Homes
              </h1>
            </div>

            <div className="container flex flex-col items-center px-4 pb-8 mx-auto text-center">
              <IoHome className="w-16 h-16" />
              <h1 className="mt-4 text-md font-semibold text-gray-100">
                Orphanages
              </h1>
            </div>

            <div className="container flex flex-col items-center px-4 pb-8 mx-auto text-center">
              <TiGroupOutline className="w-16 h-16" />
              <h1 className="mt-4 text-md font-semibold text-gray-100">
                Underprivileged Groups
              </h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
